<div #kpiChartContainer>
<div>
  <loading *ngIf="isLoading" type="kpi"> </loading>
</div>
<div *ngIf="!isLoading && kpiConfig"  #kpiChartContainer class="kpi-card">
  <!-- Header with tooltip -->
  <div class="kpi-header">
    <h3 class="kpi-title" [attr.title]="kpiConfig.title">{{ kpiConfig.title }}</h3>
    <div class="header-icons">
      <img class="info_img" matTooltip="Help" (click)="getInfoDetails()" [matMenuTriggerFor]="info" type="button" src="./../../../../assets/svgIcons/info_circle.svg"/>
      <!-- <mat-icon
        class="info-icon"
        [matTooltip]="kpiConfig.tooltip || 'Additional information'"
        matTooltipPosition="above"
      >
        info_outline
      </mat-icon> -->
      <!-- <button class="fullscreen-btn" (click)="toggleFullscreen()" matTooltip="Show Full Screen" matTooltipPosition="above">
        <mat-icon>fullscreen</mat-icon>
      </button> -->
      <img *ngIf="kpiConfig.showChart !== false && kpiConfig.visualization.data.length" class="info_img" matTooltip="Show Full Screen" (click)="toggleFullscreen()" type="button" src="./../../../../assets/svgIcons/expand_circle.svg"/>
    </div>
  </div>

  <!-- Body with metrics and visualization -->
  <div class="kpi-body"
       [class.position-bottom]="kpiConfig.chartPosition === 'bottom'"
       [class.position-right]="kpiConfig.chartPosition !== 'bottom'"
       [class.no-chart]="kpiConfig.showChart === false">
    <!-- Main metrics section -->
    <div class="metric-section">
      <div class="main-value" [style.color]="kpiConfig.fontMainColor">
        <span class="value-text"
              [matTooltip]="displayMainValue(kpiConfig.mainValue) + (kpiConfig.unit || '')"
              matTooltipPosition="above">{{ displayMainValue(kpiConfig.mainValue) }}</span><span class="unit">{{ kpiConfig.unit }}</span>
      </div>

      <!-- Trend indicator -->
      <div class="trend" [ngClass]="getTrendColorClass()" *ngIf="kpiConfig.trendFlag">
        <span class="trend-icon">{{ getTrendIcon() }}</span>
        <span class="trend-value" *ngIf="kpiConfig.trend['value'] != 0">{{ kpiConfig.trend.value }}</span>
        <span class="trend-label" [attr.title]="kpiConfig.trend.label">{{ kpiConfig.trend.label ||'' }}</span>
      </div>
      <!-- trend_flag off: show the designer's trend_label text as-is -->
      <div class="trend trend-flat" *ngIf="!kpiConfig.trendFlag && kpiConfig.trendLabel">
        <span class="trend-label" [attr.title]="kpiConfig.trendLabel">{{ kpiConfig.trendLabel }}</span>
      </div>

      <!-- Additional details section -->
      <div class="details-section" *ngIf="kpiConfig.previousValue !== undefined || kpiConfig.changeAmount !== undefined || kpiConfig.dateRange || kpiConfig.target !== undefined">
        <!-- Previous value comparison -->
        <div class="detail-item" *ngIf="kpiConfig.previousValue !== undefined">
          <span class="detail-label">Previous:</span>
          <span class="detail-value">{{ kpiConfig.previousValue }}{{ kpiConfig.unit }}</span>
        </div>

        <!-- Absolute change -->
        <div class="detail-item" *ngIf="kpiConfig.changeAmount !== undefined">
          <span class="detail-label">Change:</span>
          <span class="detail-value" [ngClass]="kpiConfig.trend.direction === 'UP' ? 'positive' : 'negative'">
            {{ kpiConfig.trend.direction === 'UP' ? '+' : '' }}{{ kpiConfig.changeAmount }}{{ kpiConfig.unit }}
          </span>
        </div>

        <!-- Date range -->
        <div class="detail-item" *ngIf="kpiConfig.dateRange">
          <span class="detail-label">Period:</span>
          <span class="detail-value">{{ kpiConfig.dateRange }}</span>
        </div>

        <!-- Target (if applicable) -->
        <div class="detail-item" *ngIf="kpiConfig.target !== undefined">
          <span class="detail-label">Target:</span>
          <span class="detail-value">{{ kpiConfig.target }}{{ kpiConfig.unit }}</span>
        </div>
      </div>

      <!-- Last updated timestamp -->
      <div class="last-updated" *ngIf="kpiConfig.lastUpdated">
        <mat-icon class="update-icon">schedule</mat-icon>
        <span>{{ kpiConfig.lastUpdated }}</span>
      </div>
    </div>

    <!-- Visualization section -->
    <div class="visualization-section" *ngIf="kpiConfig.showChart !== false">
      <div
        *ngIf="kpiConfig.visualization.type === 'category-bar'"
        class="category-label"
      >
        {{ getCategoryLabel() }}
      </div>
      <div class="chart-wrapper">
        <div
          #svgContainer
          [id]="'kpi-' + kpiConfig.visualization.type + '-chart'"
          [class]="'chart-container kpi-' + kpiConfig.visualization.type + '-chart'"
        ></div>
        <!-- Dedicated tooltip area (reserved space) -->
        <!-- <div class="tooltip-area">
          <div class="chart-tooltip-badge" style="opacity: 0;"></div>
        </div> -->
      </div>
    </div>
  </div>
</div>
</div>

<!-- Fullscreen Overlay Template (rendered via CDK Overlay) -->
<ng-template #fullscreenTemplate>
  <div class="fullscreen-overlay-container" (click)="closeFullscreen()">
    <div class="fullscreen-content" [class.compare-mode]="isCompareChanges" (click)="$event.stopPropagation()">
      <div class="fullscreen-header">
        <!-- compareChanges: title only, metrics move to the cards in the body -->
        <h2 class="fullscreen-title" *ngIf="isCompareChanges; else defaultHeaderLeft">{{ kpiConfig.title }}</h2>
        <ng-template #defaultHeaderLeft>
          <!-- Left side: title + inline metrics -->
          <div class="fullscreen-header-left">
            <h2 class="fullscreen-title">{{ kpiConfig.title }}</h2>
            <div class="fullscreen-metrics">
              <div class="fullscreen-main-value" [style.color]="kpiConfig.fontMainColor">
                {{ displayMainValue(kpiConfig.mainValue) }}<span class="unit">{{ kpiConfig.unit }}</span>
              </div>
              <div class="trend" [ngClass]="getTrendColorClass()" *ngIf="kpiConfig.trend.value != null && kpiConfig.trendFlag">
                <span class="trend-icon">{{ getTrendIcon() }}</span>
                <span class="trend-value">{{ kpiConfig.trend.value }}</span>
                <span class="trend-label">{{ kpiConfig.trend.label }}</span>
              </div>
              <div class="trend trend-flat" *ngIf="!kpiConfig.trendFlag && kpiConfig.trendLabel">
                <span class="trend-label">{{ kpiConfig.trendLabel }}</span>
              </div>
              <div class="fullscreen-details" *ngIf="kpiConfig.previousValue !== undefined || kpiConfig.changeAmount !== undefined || kpiConfig.dateRange || kpiConfig.target !== undefined">
                <div class="detail-item" *ngIf="kpiConfig.previousValue !== undefined">
                  <span class="detail-label">Previous:</span>
                  <span class="detail-value">{{ kpiConfig.previousValue }}{{ kpiConfig.unit }}</span>
                </div>
                <div class="detail-item" *ngIf="kpiConfig.changeAmount !== undefined">
                  <span class="detail-label">Change:</span>
                  <span class="detail-value" [ngClass]="kpiConfig.trend.direction === 'UP' ? 'positive' : 'negative'">
                    {{ kpiConfig.trend.direction === 'UP' ? '+' : '' }}{{ kpiConfig.changeAmount }}{{ kpiConfig.unit }}
                  </span>
                </div>
                <div class="detail-item" *ngIf="kpiConfig.dateRange">
                  <span class="detail-label">Period:</span>
                  <span class="detail-value">{{ kpiConfig.dateRange }}</span>
                </div>
                <div class="detail-item" *ngIf="kpiConfig.target !== undefined">
                  <span class="detail-label">Target:</span>
                  <span class="detail-value">{{ kpiConfig.target }}{{ kpiConfig.unit }}</span>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <!-- Right side: close button -->
        <button class="close-btn" (click)="closeFullscreen()" matTooltip="Close" matTooltipPosition="left">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      
      <div class="fullscreen-body">
        <!-- compareChanges: overall value card + last-month change card -->
        <div class="fullscreen-cards" *ngIf="isCompareChanges">
          <div class="fullscreen-card">
            <div class="card-label">Overall {{ kpiConfig.title }}</div>
            <div class="card-value" [style.color]="kpiConfig.fontMainColor">
              {{ displayMainValue(kpiConfig.mainValue) }}<span class="unit">{{ kpiConfig.unit }}</span>
            </div>
          </div>
          <div class="fullscreen-card" *ngIf="fullscreenChange as change">
            <div class="card-label">% Change {{ kpiConfig.title }}</div>
            <div class="card-value card-change">
              <span class="change-icon" [ngClass]="getFullscreenChangeClass(change.direction)">
                {{ change.direction === 'UP' ? '▲' : change.direction === 'DOWN' ? '▼' : '' }}
              </span>
              {{ change.value }}
            </div>
          </div>
        </div>

        <!-- Series legend -->
        <div class="fullscreen-legend" *ngIf="isCompareChanges">
          <span class="legend-dot" [style.background]="kpiConfig.chartColor || '#D11044'"></span>
          {{ kpiConfig.title }}
        </div>

        <!-- Chart Section -->
        <div class="fullscreen-chart">
          <div *ngIf="kpiConfig.visualization.type === 'category-bar'" class="category-label">
            {{ getCategoryLabel() }}
          </div>
          <div class="fullscreen-chart-wrapper">
            <div
              #fullscreenSvgContainer
              [id]="'kpi-fullscreen-' + kpiConfig.visualization.type + '-chart'"
              [class]="'fullscreen-chart-container kpi-fullscreen-' + kpiConfig.visualization.type + '-chart'"
            ></div>
            <div class="fullscreen-tooltip-area">
              <div class="fullscreen-chart-tooltip" style="opacity: 0;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!-- info popup -->
<mat-menu #info="matMenu" class="kpi-info-menu">
  <div class="card" style="min-width: 300px;border: none;width: auto;" (click)="$event.stopPropagation()">
    <div class="card-header d-flex justify-content-between align-items-center" style="border-bottom: none;background: #ddd;">
       <span style="font-weight: 600;">{{infoData?.info_header}}</span>

       <span (click)="closeMenu()" mat-dialog-close> 
          <svg width="16" height="16" style="width: 12px !important;height: 12px !important;" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M12.9501 0.409871L8 5.35998L3.04989 0.409871C2.5034 -0.136624 1.61634 -0.136624 1.06985 0.409871L0.409871 1.06985C-0.136624 1.61634 -0.136624 2.5034 0.409871 3.04989L5.35998 8L0.409871 12.9501C-0.136624 13.4966 -0.136624 14.3837 0.409871 14.9302L1.06985 15.5901C1.61634 16.1366 2.5034 16.1366 3.04989 15.5901L8 10.64L12.9501 15.5901C13.4966 16.1366 14.3837 16.1366 14.9302 15.5901L15.5901 14.9302C16.1366 14.3837 16.1366 13.4966 15.5901 12.9501L10.64 8L15.5901 3.04989C16.1366 2.5034 16.1366 1.61634 15.5901 1.06985L14.9302 0.409871C14.3837 -0.136624 13.4966 -0.136624 12.9501 0.409871Z" fill="#1363DF" />
          </svg>
       </span>
    </div>

    <div class="card-body">
       <div [innerHtml]="(infoData?.info_text) || '' "></div>
    </div>
  </div>
</mat-menu>

